export {
    ISingleSelectorItem,
    SharedUiSingleItemSelectorComponent,
} from "./lib/ui-single-item-selector/ui-single-item-selector.component";
